<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.add') }} {{ $tc('message.kinesitherapyConsultations', 1) }}
          </h3>
        </div>
      </div>

      <div class="card-body">

        <h3 class="text-center"> {{$t('message.infoConsultation')}}
        </h3>
        <b-form  @reset="onReset" v-if="show">
          <b-container>
            <b-row>
              <b-col sm="12">
                  <span class="obligatoire">*</span>
                  <b-form-group id="timeLine-group" :label="$tc('message.TimelineSelect', 2)" label-for="singleMotif" >
                      <select id="timeLine" v-model="$v.form.ligne_de_temps_id.$model" class="form-control is-invalid retirerBordure" @change="clearErrorField('ligne_de_temps_id')" required>
                          <option data-placeholder="true"></option>
                          <option v-for="item in lignetempsRows" :key="item.id" :value="item.id">
                              <b-badge variant="info">{{item.date}}</b-badge> {{item.motif}} 
                          </option>
                      </select>
                  <b-form-invalid-feedback v-if="$v.form.ligne_de_temps_id.$error">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <span v-if="errorshasField('ligne_de_temps_id')" style="color:red">
                                {{getErrorsField('ligne_de_temps_id')}}
                            </span>
                  </b-form-group>
              </b-col>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="institution-group"
                    :label="$t('message.institutionConsultation')"
                    label-for="institution"
                >
                  <select id="institution" v-model="$v.form.institution.$model"
                          @change="clearErrorField('etablissement_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.institution.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="contributors-group"
                    :label="$tc('message.contributors',2)"
                    label-for="contributors"
                >
                  <select id="contributors" v-model="$v.form.contributors.$model"
                          @change="clearErrorField('contributeurs')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('contributeurs')" style="color:red">
                                    {{getErrorsField('contributeurs')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="consultation-group"
                    :label="$t('message.consultationDate')"
                    label-for="consultation"
                    description="">
                  <b-form-input
                      id="consultation"
                      v-model="$v.form.date_consultation.$model"
                      :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_consultation')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.date_consultation.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_consultation')">
                    {{ getErrorsField('date_consultation') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="singleMotif-group"
                    :label="$tc('message.reasons', 2)"
                    label-for="singleMotif"
                >
                  <select id="singleMotif" v-model="$v.form.motifs.$model" multiple
                          class="form-control is-invalid retirerBordure"
                          @change="clearErrorField('motifs')"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mReasons" :key="item.value" :value="item.text">
                      {{ item.text }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.motifs.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('motifs')" style="color:red">
                                    {{getErrorsField('motifs')}}
                                    </span>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="anamese-group"
                    :label="$t('message.anamnesis')"
                    label-for="anamese"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.anamese.$model"
                      :state="$v.form.anamese.$dirty ? !(errorshasField('anamese') || $v.form.anamese.$error) : null"
                      @focus="clearErrorField('anamese')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('anamese')">
                    {{ getErrorsField('anamese') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="occupation-group"
                    :label="$t('message.profession')"
                    label-for="occupation-propose"
                >
                  <b-form-input
                      id="occupation"
                      v-model="$v.form.profession.$model"
                      :state="$v.form.profession.$dirty ? !(errorshasField('profession') || $v.form.profession.$error) : null"
                      @focus="clearErrorField('profession')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('profession')">
                    {{ getErrorsField('profession') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="evaluation-global-group"
                    :label="$t('message.evaluationGlobale')"
                    label-for="evaluation-global"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.evaluation_globale.$model"
                      :state="$v.form.evaluation_globale.$dirty ? !(errorshasField('evaluation-globale') || $v.form.evaluation_globale.$error) : null"
                      @focus="clearErrorField('evaluation-globale')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('evaluation-globale')">
                    {{ getErrorsField('evaluation-globale') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="impression-diagnostique-group"
                    :label="$t('message.impressionDiagnostique')"
                    label-for="impression-diagnostique"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.impression_diagnostique.$model"
                      :state="$v.form.impression_diagnostique.$dirty ? !(errorshasField('impression-diagnostique') || $v.form.impression_diagnostique.$error) : null"
                      @focus="clearErrorField('impression-diagnostique')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('impression-diagnostique')">
                    {{ getErrorsField('impression-diagnostique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="examens-complementaires-group"
                    :label="$t('message.examensComplementaires')"
                    label-for="examens-complementaires"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.examens_complementaires.$model"
                      :state="$v.form.examens_complementaires.$dirty ? !(errorshasField('examens-complementaires') || $v.form.examens_complementaires.$error) : null"
                      @focus="clearErrorField('examens-complementaires')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('examens-complementaires')">
                    {{ getErrorsField('examens-complementaires') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="conduite-group"
                    :label="$t('message.suggestTreatment')"
                    label-for="conduite"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.conduite.$model"
                      :state="$v.form.conduite.$dirty ? !(errorshasField('conduite') || $v.form.conduite.$error) : null"
                      @focus="clearErrorField('conduite')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('conduite')">
                    {{ getErrorsField('conduite') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="8">
                <b-form-group
                    id="upload-group"
                    :label="$t('message.uploadFile')"
                    label-for="upload"
                >
                  <b-form-file multiple
                               type="file"
                               accept=".jpeg, .png, .gif, .pdf, .docx"
                               ref="file_input"
                               id="upload"
                               :state="$v.form.documents.$dirty ? !$v.form.documents.$error : null"
                               :placeholder="$t('message.uploadFile')"
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="dark">{{ names[0] }}</b-badge>
                      <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                        + {{ names.length - 1 }} More documents
                      </b-badge>
                    </template>
                  </b-form-file>
                  <span style="color: red" v-if="errorshasField('documents')">
                                        {{ getErrorsField('documents') }}
                                    </span>

                  <span style="color: red" v-if="maxFileSize.length>0" >{{ maxFileSize }}</span>

                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                    id="u"
                    label="."
                    label-for="upload"
                >
                  <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="date_rdv"
                    :label="$t('message.appointmentDate')"
                    label-for="appointmentDate"
                >
                  <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.dateRdv.$model"></vue-ctk-date-time-picker>
                </b-form-group>

              </b-col>
              <b-col sm="12">
                <b-form-group
                    id="traitement-appointmentReason-group"
                    :label="$t('message.appointmentReason')"
                    label-for="appointmentReason"
                >
                  <editor
                      :api-key="tinyKey"
                      id="appointmentReason"
                      v-model="$v.form.motifRdv.$model"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" sm="12">
                <b-form-group
                    id="isConsultantDoctor-group"
                    :label="$t('message.isConsultantDoctor')"
                    label-for="isConsultantDoctor">
                  <b-form-radio
                      v-model="$v.form.isConsultantDoctor.$model"
                      name="isConsultantDoctor"
                      value="true"
                      :inline="true"
                  >
                    {{ $t('message.yes') }}
                  </b-form-radio>
                  <b-form-radio
                      v-model="$v.form.isConsultantDoctor.$model"
                      name="isConsultantDoctor"
                      value="false"
                      :inline="true"
                  >
                    {{ $t('message.no') }}
                  </b-form-radio>
                  <b-form-invalid-feedback v-if="errorshasField('isConsultantDoctor')">
                    {{ getErrorsField('isConsultantDoctor') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="$v.form.isConsultantDoctor.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                </b-form-group>

              </b-col>
            </b-row>
            <b-row v-if="form.isConsultantDoctor === 'false'" class="mt-3">
              <b-col md="6" sm="12">
                <b-form-group
                    id="consultantDoctor-group"
                    :label="$t('message.select')+' '+$tc('message.medecin',1)"
                    label-for="patient">

                  <b-form-radio
                      v-model="$v.form.medecinSource.$model"
                      name="medecinSource"
                      value="fromMedicasure"
                      :inline="true"
                  >
                    {{ $t('message.fromMedicasure') }}
                  </b-form-radio>
                  <b-form-radio
                      v-model="$v.form.medecinSource.$model"
                      name="medecinSource"
                      value="fromOthers"
                      :inline="true"
                  >
                    {{ $t('message.fromOthers') }}
                  </b-form-radio>
                  <!-- Options -->
                  <select
                      v-if="form.medecinSource === 'fromMedicasure'"
                      id="consultantDoctor"
                      v-model="$v.form.practicien_id.$model"
                      class="form-control is-invalid border-light mt-2"
                  >
                    <option v-for="item in mContributors" :value="item.id" :key="item.id">
                      {{ item.nom }}
                    </option>
                  </select>

                  <b-form-input
                      id="doctorName"
                      class="mt-2"
                      v-else
                      v-model="$v.form.doctorName.$model"
                      :placeholder="$t('message.preciseDoctorName')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.save') }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required,minLength } from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
import moment from 'moment';
import $ from 'jquery';
import Editor from '@tinymce/tinymce-vue';
import AppConfig from "../../../constants/AppConfig";

export default {
  name: "AddGeneralMedicine",

  components: {
    editor: Editor
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "file",
      "reasons",
      "allergies",
      "institutions",
      "userInstitutions",
      "errors",
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasAssistante',
      'hasPraticienRole','Timelines']),

    mMedicalFile: function () {
      return (_.isUndefined(this.file) || _.isNull(this.file)) ? [] : this.file;
    },

    mInstitutions: function () {
      let iArray = [];

      _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
        let i = {};

        i.nom = institution.name;
        i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
        i.date = moment(institution.created_at).format('DD-MM-YYYY');
        i.id = institution.id;
        i.slug = institution.slug;

        iArray.push(i);
      });

      return iArray;
    },

    mReasons: function () {
      let rArray = [];

      if (!_.isUndefined(this.reasons)) {
        _.forEach(this.reasons, function (reason) {
          rArray.push({text: reason.description, value: reason.id})
        })
        return rArray;
      }
      return rArray;
    },

    descriptions: function () {
      let aArray = [];

      if (!_.isUndefined(this.allergies)) {
        _.forEach(this.allergies, function (allergy) {
          aArray.push({text: allergy.description, value: allergy.id})
        })
        return aArray;
      }
      return aArray;
    },

    can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
      }
    },
    lignetempsRows: function () {
      let self = this;
      let mArray = [];
      _.forEach(_.orderBy(self.Timelines, ['created_at'], ['desc']), function (timelines) {
          let motifs = "";
          let ids = "";

          if (timelines.hasOwnProperty('motif')) {

              motifs = timelines.motif.description;
              // ligne_de_temps_id = timelines.id;
              // console.log('ligne_de_temps_id', ligne_de_temps_id);

              if (motifs.length > 105) {
                  motifs = timelines.motif.description.substring(0, 105) + " ...";
              }
          }
          mArray.push({
              id: timelines.id,
              date: timelines.date_consultation,
              motif: motifs,
              etat: timelines.etat == null ? true : false,
          });
      });
      let sArray = mArray;
      mArray = self.filterResult(sArray, mArray);
      return mArray;
    },

    today: function () {
      return moment((new Date())).format('YYYY-MM-DD');
    },

    mAllergies: function () {
      return (typeof this.mMedicalFile.allergies == "object" ? this.mMedicalFile.allergies : []);
    },

    mAntecedents: function () {
      let mArray = (typeof this.mMedicalFile.antecedents == "object" ? this.mMedicalFile.antecedents : []);
      let cMedecines = this.mMedicalFile.consultations_medecine;
      let cCardiologies = this.mMedicalFile.cardiologies;

      _.forEach(cCardiologies, function(cardiologie){
        if (!_.isNull(cardiologie.conclusion) && cardiologie.conclusion !=='null'){
          let c = {}
          c.type = 'Consultation';
          c.description = cardiologie.conclusion;
          c.date = moment(cardiologie.updated_at).format('YYYY-MM-DD');
          mArray.unshift(c);
        }
      });

      _.forEach(cMedecines, function (medecine){
        _.forEach(medecine.conclusions, function(conclusion){
          let m = {};
          m.type = 'Consultation';
          m.description = conclusion.description;
          m.date = moment(conclusion.updated_at).format('YYYY-MM-DD')
          mArray.unshift(m);
        })
      })

      mArray = _.orderBy(mArray,['date'],['asc']);

      return mArray;
    },

    allergiesRows: function () {
      let aArray = [];

      _.forEach(_.orderBy(this.mAllergies, ['created_at'], ['desc']), function (allergy) {
        aArray.push({description: allergy.description, slug: allergy.slug})
      })

      return aArray;
    },

    antecedentsRows: function () {

      return _.chain(_.orderBy(this.mAntecedents, ['created_at'], ['desc']))
          .groupBy("type")
          .map((value, key) => ({mode: "span", label: key, html: false, children: value}))
          .value();

    },

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          p.id = practitioner.user.id;
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          d.id = doctor.user.id;

          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    }
  },

  data() {
    return {
      maxFileSize:'',
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      afficherAllergie: false,
      afficherAntecedent: false,
      file_id: this.$route.params.file,
      hasChild: false,
      smoke: false,
      drink: false,
      watch: {
        hasChild: function (oldValue, newValue) {
          if (newValue == false) {
            this.form.nbre_enfant = "0";
          }
        },
        smoke: function (oldValue, newValue) {
          if (newValue == false) {
            this.form.tabac = 0;
          }
        },
        drink: function (oldValue, newValue) {
          if (newValue == false) {
            this.form.alcool = "0";
          }
        },
      },
      allergiesColumns: [
        {
          label: 'Description',
          field: 'description',
        },
        // {
        //     label: this.$i18n.t('message.startDate'),
        //     field: 'date',
        //     type: 'date',
        //     dateInputFormat: 'yyyy-MM-dd',
        //     dateOutputFormat: 'dd/MM/yyyy',
        // },
      ],

      antecedentsColumns: [
        {
          label: this.$i18n.tc('message.types', 1),
          field: 'type',

        },
        {
          label: 'Description',
          field: 'description',
          html:true
        },
        {
          label: this.$i18n.t('message.startDate'),
          field: 'date',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd/MM/yyyy',
        },
      ],

      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled: {enabled: true},

      sort: {
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

      form: {
        documents:[],
        motifs: [],
        date_consultation: this.today,
        ligne_de_temps_id: '',
        anamese: '',
        examen_clinique: '',
        examen_complementaire: '',
        profession: '',
        conduite: '',
        evaluation_globale: '',
        examens_complementaires: '',
        impression_diagnostique: '',
        contributors: [],
        institution: null,
        dateRdv:null,
        motifRdv:null,
        isConsultantDoctor: 'true',
        practicien_id: JSON.parse(localStorage.getItem('user'))['id'],
        doctorName: '',
        medecinSource: 'fromMedicasure',
      },

      antecedents: {
        type: '',
        description: '',
        date: this.today,
      },

      allergiesForm: {
        description: [],
        // date:''
      },


      show: true,
      types: [
        {value: 'Médical', text: 'Médical'},
        {value: 'Chirugical', text: 'Chirugical'},
        {value: 'Gynéco-obstétrique', text: 'Gynéco-obstétrique'},
        {value: 'Familial', text: 'Familial'}
      ],
    }
  },

  methods: {
    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getControlDoctors', { args : args });
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPractitioners', { args : args });
    },

    cleardocuments() {
      this.$refs['file_input'].reset()
    },
    filterResult(sArray, mArray) {
      if (this.filteredValue == 1) {
          mArray = sArray;
      } else if (this.filteredValue == 2) {
          //Non archivés
          mArray = _.filter(mArray, function (medecine) {
              return _.isNull(medecine.archievedAt);
          })
      } else if (this.filteredValue == 3) {
          //Non transmis
          mArray = _.filter(mArray, function (medecine) {
              return _.isNull(medecine.passedAt);
          })
      } else if (this.filteredValue == 4) {
          //Archivés
          mArray = _.filter(mArray, function (medecine) {
              return !_.isNull(medecine.archievedAt);
          })
      } else if (this.filteredValue == 5) {
          //Transmis
          mArray = _.filter(mArray, function (medecine) {
              return !_.isNull(medecine.passedAt);
          })
      }
      return mArray;
    },

    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', {args: args});
    },

    pathTo(element) {
      if (this.$route.fullPath.includes('#')) {
        let position = this.$route.fullPath.search('#');
        return this.$route.fullPath.substr(0, position) + element;
      }
      return this.$route.fullPath + element;
    },

    toggleAntecedent() {
      this.afficherAntecedent = !this.afficherAntecedent;
    },

    toggleAllergie() {
      this.afficherAllergie = !this.afficherAllergie;
    },

    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getInstitutions', {args: args});
    },

    getAllergies() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getAllergies', {args: args});
    },

    onAntecedentRowClick(params) {
      // this.$router.push({name: 'antecedent', params: {antecedent: params.row.slug, file: this.file_id}});
    },

    onAllergieRowClick(params) {
      this.$router.push({name: 'allergy', params: {allergy: params.row.slug}});
    },

    notEmpty(item) {
      return item.length > 0;
    },

    getReasons() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getReasons', {args: args});
    },

    getMedicalFile() {
      let args = {
        file: this.file_id
      };

      this.$store.dispatch("getMedicalFile", {args});
    },
    getTimelines() {
      let args = {
          file: this.file_id,
      };
      
      this.$store.dispatch("getTimelines", {
          args
      });
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      let files = this.$refs.file_input.selectedFile;
      let nomFichier = "";
      if (!_.isNull(files)) {
        _.forEach(files, function (file, key) {
          let taille = (((file.size) / 1024) / 1024).toFixed(4);
          if (taille > 5) {
            nomFichier += key == 0 ? '' : ',' + file.name + ": " + taille + " Mo";
          }
        });

        if (nomFichier.length > 0) {
          this.maxFileSize = this.$i18n.t('message.maxFileSize') + nomFichier;
        } else {
          this.maxFileSize = "";
        }
      }
      if (!_.isNull(this.form.dateRdv)){
        this.form.dateRdv = moment(this.form.dateRdv).format('YYYY-MM-DD HH:mm');
      }
      if (!this.$v.form.$invalid && this.maxFileSize.length ==0) {
        let formData = new FormData();

        let praticien_id = '';
        if (this.form.isConsultantDoctor === 'true') {
          if (this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
            praticien_id = JSON.parse(localStorage.getItem('user'))['id'];
          }

        } else if (this.form.medecinSource === 'fromMedicasure') {
          praticien_id = this.form.practicien_id;
        } else {
          praticien_id = this.form.doctorName;
        }

        
        formData.append('dossier_medical_id', this.file.id);
        formData.append('contributeurs', this.form.contributors);
        formData.append('date_consultation', this.form.date_consultation);
        formData.append('anamnese', this.form.anamese);
        formData.append('evaluation_globale', this.form.evaluation_globale);
        formData.append('impression_diagnostique', this.form.impression_diagnostique);
        formData.append('examens_complementaires', this.form.examens_complementaires);
        formData.append('conduite_a_tenir', this.form.conduite);
        formData.append('profession', this.form.profession);
        formData.append('etablissement_id', this.form.institution);
        formData.append('dateRdv', this.form.dateRdv);
        formData.append('motifRdv', this.form.motifRdv);
        formData.append('praticien_id', ''+praticien_id);
        formData.append('ligne_de_temps_id', this.form.ligne_de_temps_id);
        console.log('ligne_de_temps_id', this.form.ligne_de_temps_id);
        // let self= this;
        if (!_.isNull(files)) {
          for (var i = 0; i < this.$refs.file_input.selectedFile.length; i++) {
            let file = this.$refs.file_input.selectedFile[i];
            formData.append('documents[' + i + ']', file);
          }
        }

        let successMessage = this.$i18n.t('message.generalConsultationCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };


        this.$store.dispatch('createKinesitherapieConsultation', {args: formData, errorMessages, successMessage})
            .then(() => {
              // Scroll to the top of the page
              document.body.scrollTop = 0; // For Safari
              document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            });
      } else {
        $('html, body').animate({scrollTop: 0}, '300');
      }
    },

    onAllergieSubmit: function (evt) {
      evt.preventDefault();

      this.$v.allergiesForm.$touch();

      if (!this.$v.allergiesForm.$invalid) {
        let args = {
          dossier_medical_id: this.file.id,
          description: this.allergiesForm.description,
          // date: this.allergiesForm.date,
        };

        let successMessage = this.$i18n.t('message.allergyCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('addAllergyVersion', {args, errorMessages, successMessage})
            .then(() => {
              // Scroll to the top of the page
              // document.body.scrollTop = 0; // For Safari
              // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
              // this.$v.allergiesForm.date.$model = "";
              this.$v.allergiesForm.description.$model = [];
              // this.$v.allergiesForm.description.$invalid =false;
              // this.$v.allergiesForm.date.$invalid = false;


            });
      }
    },

    onAntecedentSubmit: function (evt) {
      evt.preventDefault();

      this.$v.antecedents.$touch();

      if (!this.$v.antecedents.$invalid) {
        let args = {
          dossier_medical_id: this.file.id,
          type: this.antecedents.type,
          description: this.antecedents.description,
          date: this.antecedents.date
        };

        let successMessage = this.$i18n.t('message.antecedentCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('createAntecedent', {args, errorMessages, successMessage})
            .then(() => {

              // // Scroll to the top of the page
              // document.body.scrollTop = 0; // For Safari
              // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

              this.$v.antecedents.date.$model = '';
              this.$v.antecedents.description.$model = '';
              this.$v.antecedents.type.$model = '';

              this.$v.antecedents.type.$invalid = false;
              this.$v.antecedents.type.$dirty = false;

              this.$v.antecedents.date.$invalid = false;

              this.$v.antecedents.description.$invalid = false;
            });
      }
    },

    onReset: function (evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.dossier_medical_id = '';
      this.form.date_consultation = '';
      this.form.mode_de_vie = '';
      this.form.anamese = '';
      this.form.examen_clinique = '';
      this.form.examen_complementaire = '';
      this.form.traitement_propose = '';
      this.motifs = [''];

      // Trick to reset/clear native browser form validation state
      this.show = false;

      this.$nextTick(() => {
        this.show = true;
      });
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);
    }
  },

  validations: {
    form: {
      practicien_id:{
      },

      isConsultantDoctor: {

      },

      medecinSource: {

      },

      doctorName: {

      },
      contributors:{

      },
      motifs: {
        required
      },

      date_consultation: {
        required
      },

      anamese: {
        //
      },
      ligne_de_temps_id: {},
      examen_clinique: {
        //
      },

      examen_complementaire: {
        //
      },

      conclusions: {
        //
      },

      profession: {},


      institution: {
        required
      },

      evaluation_globale:{

      },

      impression_diagnostique:{},
      
      conduite:{},

      examens_complementaires:{},

      traitements: {},

      documents: {
        // required
      },

      dateRdv: {},
      motifRdv: {}
    },

    antecedents: {

      type: {
        required
      },

      description: {
        required,
        minLength: minLength(3)
      },

      date: {},
    },

    allergiesForm: {

      description: {
        required
      },

      date: {},
    },

  },

  mounted() {
    // Fetch control doctor list
    this.getDoctors();
    // Fetch timeline doctor list
    this.getTimelines();
    // Fetch practitioner list
    this.getPractitioners();

    // Fetch user institution list
    this.getUserInstitutions();

    // Fetch institution list
    this.getInstitutions();
    // Retrieve list of medical documents
    this.getMedicalFile();

    // Fetch reason list
    this.getReasons();

    this.$v.form.date_consultation.$model = this.today;

    var singleMotif = new SlimSelect({
      select: '#singleMotif',
      placeholder: 'Select or add reason',
      addable: function (value) {
        if (singleMotif.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    new SlimSelect({
      select: '#institution',
      placeholder: 'Select institution',
      limit: 1
    });

    new SlimSelect({
      select: '#contributors',
      placeholder: 'Select contributors',
      limit: 5
    });
    new SlimSelect({
      select: '#timeLine',
      placeholder: 'Select or add timeLine',
      limit: 5

    });


    // Fetch allergy list
    this.getAllergies();

    var btn = $('#button');

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });

  }
}
</script>

<style scoped>
</style>